import type { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { ProtectedRoute } from '@/components/guards/ProtectedRoute'
import OrganizationValidator from '@/components/validators/OrganizationValidator'

// Unified auth page - single /login with all auth flows (login, context selection, welcome)
const UnifiedAuthPage = lazy(() => import('@/modules/auth/UnifiedAuthPage').then(m => ({ default: m.UnifiedAuthPage })))
const NoModulesEnabledPage = lazy(() => import('@/pages/auth/NoModulesEnabledPage').then(m => ({ default: m.NoModulesEnabledPage })))

// Lazy load organization pages
const AcceptInvitePage = lazy(() => import('@/pages/organization/AcceptInvitePage').then(m => ({ default: m.AcceptInvitePage })))

/** Redirect /select-context to /login?stage=context, preserving location.state */
function SelectContextRedirect() {
  const location = useLocation()
  return <Navigate to={{ pathname: '/login', search: '?stage=context' }} replace state={location.state} />
}

/** Redirect /welcome to /login?stage=welcome */
function WelcomeRedirect() {
  return <Navigate to="/login?stage=welcome" replace />
}

export const authRoutes: RouteObject[] = [
  {
    path: '/login',
    element: (
      <OrganizationValidator>
        <UnifiedAuthPage />
      </OrganizationValidator>
    ),
  },
  {
    path: '/register',
    element: <Navigate to="/onboarding" replace />,
  },
  {
    path: '/select-context',
    element: <SelectContextRedirect />,
  },
  {
    path: '/welcome',
    element: <WelcomeRedirect />,
  },
  {
    path: '/no-modules-enabled',
    element: (
      <ProtectedRoute>
        <NoModulesEnabledPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/create-organization',
    element: <Navigate to="/onboarding?step=organization-profile&resume=true" replace />,
  },
  {
    path: '/accept-invites',
    element: (
      <ProtectedRoute>
        <AcceptInvitePage />
      </ProtectedRoute>
    ),
  },
]
